import React, { useContext } from 'react';
import { AppContext } from '../../../../common/context/';
import { BaseConfirmModal } from '../BaseConfirmModal';
import { DisassociateCostCentersProps } from './DisassociateCostCenters.Props';

export const DisassociateCostCentersModal = ({
    employee,
    endDate,
    isOpen,
    startDate,
    listToDelete,
    onClose,
    onSubmit,
}: DisassociateCostCentersProps) => {
    const { langResources } = useContext(AppContext);

    const handlerClose = () => {
        onClose(false);
    };

    const handlerSubmit = () => {
        onClose(false);
        onSubmit(listToDelete.map((item) => item.id));
    };

    return (
        <BaseConfirmModal
            isLoading={false}
            modalTitle={langResources['disassociate.cost.center.modal']['title']}
            onClose={handlerClose}
            onSubmit={handlerSubmit}
            isOpen={isOpen}
            isShowControls={true}
            textButton={langResources['basemodal.save.button']}
        >
            <div className='modal-body text-dark position-relative'>
                <div
                    className='row '
                    style={{ maxHeight: '50vh', overflowY: 'scroll' }}
                >
                    <table className='table  w-100 text-dark text-center position-relative'>
                        <thead
                            className=' text-black w-100 text-center position-sticky p-0 m-0'
                            style={{ top: '0px', background: '#fff' }}
                        >
                            <tr>
                                <th className='fw-bold'>
                                    {
                                        langResources[
                                            'disassociate.cost.center.modal'
                                        ]['employee.label']
                                    }
                                </th>
                                <th className='fw-bold'>
                                    {
                                        langResources[
                                            'disassociate.cost.center.modal'
                                        ]['date.label']
                                    }
                                </th>
                                <th className='fw-bold'>
                                    {
                                        langResources[
                                            'disassociate.cost.center.modal'
                                        ]['cost.center.label']
                                    }
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {listToDelete.map((item) => (
                                <tr key={item.id}>
                                    <th className='p-2 text-start'>
                                        {item.employee}
                                    </th>
                                    <th className='p-2'>{item.date}</th>
                                    <th className='p-2'>
                                        {item.costCenter?.costCenterName}
                                    </th>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </BaseConfirmModal>
    );
};
